import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  generateVoAreports({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.VoAReport.voaOrderReport}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        } else if (error.response && error.response.status === 400) {
          return error.response
        }
        return error
      })
  },
  async fetchVoAreports({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.VoAReport.GetOrderDetails}?orderId=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  async generatepdfReports({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.VoAReport.generateReport}?orderId=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async resendInvitationEmail({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoAReport.resendEmail}?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
}
function setHeaders() {
  const path = window.location.href
  const url = path.includes('vod-otpscreen')
  if (url) {
    return {
      'Content-Type': 'application/json',
      Authorization: '',
    }
  } else {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    }
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
